import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BracketMatchView, BracketSlotView } from './tournament-bracket-page.models';

@Component({
  selector: 'app-tournament-bracket-match-card',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './tournament-bracket-match-card.component.html',
  styleUrl: './tournament-bracket-match-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TournamentBracketMatchCardComponent {
  @Input({ required: true }) match!: BracketMatchView;
  @Input() compact = false;
  @Input() inactive = false;
  @Input() inactiveLabel: string | null = null;
  @Input() reportScoreHref: string | null = null;
  @Input() reportScoreQueryParams: Record<string, string> | null = null;
  @Input() reportScoreLabel = 'Report score';

  slotName(slot: BracketSlotView | undefined): string {
    if (!slot) {
      return 'TBD';
    }

    return slot.team?.name || slot.source_label || 'TBD';
  }

  isWinningSlot(slot: BracketSlotView | undefined): boolean {
    if (!slot?.team || !this.match?.winner_team) {
      return false;
    }

    return slot.team.id === this.match.winner_team.id;
  }
}
